import { useEffect, useCallback } from 'react';
import { MailboxSettings } from '@components/Mailbox/MailboxSettings';
import { useMailboxConnections } from '@api/hooks/useMailbox';
import type { OnboardingConfig } from '@/types/onboarding';

interface MailboxIntegrationStepProps {
  config: OnboardingConfig['mailbox_integration'] | undefined;
  onChange: (config: OnboardingConfig['mailbox_integration'] | undefined) => void;
  onSaveStateForOAuth?: () => void;
}

export const MailboxIntegrationStep = ({ onChange, onSaveStateForOAuth }: MailboxIntegrationStepProps) => {
  const { data: connectionsData } = useMailboxConnections();
  const connections = connectionsData?.connections ?? [];
  const hasConnection = connections.length > 0;

  const stableOnChange = useCallback(onChange, [onChange]);

  // Sync connection status to parent wizard config
  useEffect(() => {
    if (hasConnection) {
      const conn = connections[0];
      stableOnChange({
        provider: 'microsoft_graph',
        folder: 'Inbox',
        rules: {
          from_senders: conn.filter_rules?.senders ?? [],
          attachments_only: true,
          subject_contains: '',
        },
      });
    } else {
      stableOnChange(undefined);
    }
  }, [hasConnection, connections, stableOnChange]);

  return <MailboxSettings mode="onboarding" onBeforeOAuthRedirect={onSaveStateForOAuth} />;
};
